"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.conversationSchema = exports.conversationStatusesSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const message_1 = require("./message");
const platform_1 = require("./platform");
const voice_1 = require("./voice");
exports.conversationStatusesSchema = zod_1.default.enum([
    "completed",
    "pending",
    "active",
    "ongoing",
    "evaluated",
    "expired",
]);
exports.conversationSchema = zod_1.default.object({
    _id: zod_1.default.string(),
    createdAt: zod_1.default.coerce.date(),
    updatedAt: zod_1.default.coerce.date(),
    platform: platform_1.platformSchema,
    status: exports.conversationStatusesSchema,
    display: zod_1.default.object({
        voice: voice_1.voiceSchema,
    }),
    lastMessage: message_1.messageSchema
        .pick({
        originalTranscript: true,
        from: true,
    })
        .nullish(),
});
//# sourceMappingURL=conversation.js.map